/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './events.scss';

/* eslint-disable import/no-unresolved, import/default */

import eventsTemplate from './events.tpl.html';
import eventDescriptionDetails from "../event/event-description-details.tpl.html";

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.event.events', [])
    .directive('tkEvents', Events)
    .name;

/*@ngInject*/
function Events() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            entityId: '=',
            allAlarms: '=?'
        },
        controller: EventsController,
        controllerAs: 'vm',
        templateUrl: eventsTemplate
    };
}

/*@ngInject*/
function EventsController($rootScope, $scope, $state, userService, eventService, gatewayService, deviceService, integrationService, $filter, $translate, $mdMedia, types, $document, $mdDialog, $timeout, importExport) {

    const MAX_NUM_OF_EVENTS_TO_STORE = 1000;

    var vm = this;
    let reloadDebounceTimer;

    vm.$onInit = function () {
        vm.types = types;

        vm.gwEventNameValues = Object.entries(vm.types.eventName).map(( [, v] ) => (v)).filter(function (eventNameObj) {
            return angular.isDefined(eventNameObj.gw) && eventNameObj.gw;
        });

        vm.allEvents = [];
        vm.totalElemets = 0;
        vm.events = [];
        vm.rowsCount = 0;

        vm.query = {
            order: '-startTs',
            limit: 15,
            page: 1,
            search: null
        };

        vm.limitOptions =
            [15, 30, 45];

        vm.reload = reload;

        vm.onReorder = function () {
            updateEvents();
        };

        vm.onPaginate = function () {
            reload();
        };

        vm.loading = function () {
            return $rootScope.loading;
        };

        vm.raisedOnly = vm.allAlarms;

        vm.displayOpenDetails = displayOpenDetails;
        vm.openEntityDetails = openEntityDetails;
        vm.getLabel = getLabel;
        vm.getLabelIcon = getLabelIcon;
        vm.showDescriptionDetails = showDescriptionDetails;

        vm.exportAlarms = exportAlarms;
        vm.cancelExporting = cancelExporting;
        resetExporting();

        resetFilter();
    };

    $scope.$watch(function () {
        return $mdMedia('gt-md');
    }, function (isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [15, 30, 45];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$watch('vm.entityId', (newVal) => {
        if (newVal) {
            resetPage();
            resetFilter();
            reload();
        }
    });

    $scope.$watch('vm.allAlarms', (newVal) => {
        if (newVal) {
            resetPage();
            resetFilter();
            reload();
        }
    });

    $scope.$watch("vm.eventType", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            resetPage();
            reloadWithDebounce();
        }
    });

    $scope.$watch("vm.eventTypes", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            resetPage();
            reloadWithDebounce();
        }
    });

    $scope.$watch("vm.states", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal) && !vm.raisedOnly) {
            resetPage();
            reloadWithDebounce();
        }
    });

    $scope.$watch("vm.sources", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            resetPage();
            reloadWithDebounce();
        }
    });

    $scope.$watch("vm.severities", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            resetPage();
            reloadWithDebounce();
        }
    });

    $scope.$watch("vm.eventNames", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            resetPage();
            reloadWithDebounce();
        }
    });

    $scope.$watch("vm.entityName", function (newVal, prevVal) {
        if (!angular.equals(newVal, prevVal)) {
            resetPage();
            reloadWithDebounce();
        }
    });

    $scope.$watch("vm.timewindow", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            resetPage();
            reload();
        }
    }, true);

    $scope.$watch("vm.query.search", function (newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            resetPage();
            updateEvents();
        }
    });

    $scope.$watch("vm.raisedOnly", function (newVal, prevVal) {
        if (!angular.equals(newVal, prevVal)) {
            vm.states = [];
            resetPage();
            reload();
        }
    });

    function reloadWithDebounce() {
        if (reloadDebounceTimer) {
            $timeout.cancel(reloadDebounceTimer);
        }
        reloadDebounceTimer = $timeout(reload, 1500);
    }

    function resetFilter() {
        vm.query.search = null;
        vm.timewindow = {
            history: {
                timewindowMs: 24 * 60 * 60 * 1000 // 1 day
            }
        };
        if (vm.allAlarms) {
            vm.eventTypes = [];
            vm.sources = [];
        } else {
            vm.eventType = types.eventType.ALARM.value;
        }
        vm.states = [];
        vm.severities = [];
        vm.eventNames = [];
        vm.entityName = ""
        vm.raisedOnly = vm.allAlarms;
        // vm.ituTypes = [];
    }

    function resetPage() {
        vm.query.page = 1;
    }

    function reload() {
        vm.allEvents.length = 0;
        vm.events.length = 0;
        vm.rowsCount = 0;
        var startTs;
        var endTs;
        if (vm.timewindow.history.timewindowMs) {
            var currentTime = (new Date).getTime();
            startTs = currentTime - vm.timewindow.history.timewindowMs;
            endTs = null;
        } else {
            startTs = vm.timewindow.history.fixedTimewindow.startTimeMs;
            endTs = vm.timewindow.history.fixedTimewindow.endTimeMs;
        }
        if (vm.allAlarms) {
            let loadEventsFunc = vm.raisedOnly ? eventService.getAllRaisedEvents : eventService.getAllEvents;
            vm.eventsPromise = loadEventsFunc(vm.eventTypes, vm.states, vm.severities, vm.eventNames, /*vm.ituTypes,*/ vm.entityName, vm.sources, startTs, endTs, vm.query.limit, (vm.query.page - 1));
        } else {
            let loadEventsFunc = vm.raisedOnly ? eventService.getEntityRaisedEvents : eventService.getEntityEvents;
            vm.eventsPromise = loadEventsFunc(vm.entityId.entityType, vm.states, vm.severities, vm.eventNames, /*vm.ituTypes,*/ vm.entityId.id, vm.eventType, startTs, endTs, vm.query.limit, (vm.query.page - 1));
        }
        vm.eventsPromise.then(
            (result) => {
                if (result.data && result.data.length > 0) {
                    vm.allEvents = result.data;
                    vm.allEvents.forEach((event) => {
                        event.severityText = $translate.instant(vm.types.severity[event.severity].name);
                        event.stateText = $translate.instant(vm.types.eventState[event.state].name);
                        event.entityTypeName = $translate.instant(vm.types.entityTypeTranslations[event.source].name);
                        event.typeName = $translate.instant(vm.types.eventType[event.eventType].typeName);
                        // event.ituTypeText = $translate.instant(vm.types.ituType[event.ituType].name);
                        event.eventNameText = "";
                        if (event.eventName != null) {
                            event.eventNameText = event.eventName in vm.types.eventName 
                                ? $translate.instant(vm.types.eventName[event.eventName].name) 
                                : event.eventName;
                        }
                    });
                    vm.totalElemets = getTotalElements(result);
                    updateEvents();
                } else {
                    revertPageInPaginator();
                }
            },
            () => {
                updateEvents();
            }
        );
    }

    function revertPageInPaginator() {
        if (vm.query.page > 1) {
            vm.query.page--;
        }
        if (vm.totalElemets > 0) {
            vm.totalElemets--;
        }
    }

    // This is done to reuse the same table-pagination component for scrolling pagination
    function getTotalElements(result) {
        let totalElements = result.page * result.limit + result.data.length;
        if (result.data.length === result.limit) {
            totalElements++;
        }
        return totalElements;
    }
    
    
    function updateEvents() {
        var result = $filter('orderBy')(vm.allEvents, vm.query.order);
        if (vm.totalElemets > vm.query.limit) {
            vm.rowsCount = vm.totalElemets;
        } else {
            vm.rowsCount = result.length;
        }
        vm.events = result;
    }

    function resetExporting() {
        vm.exportInProgress = false;
        vm.exportRowsFetched = 0;
    }

    function cancelExporting() {
        vm.exportCancelled = true;
        resetExporting();
    }

    function getExportTimeFrame() {
        var startTs, endTs;
        if (vm.timewindow.history.timewindowMs) {
            var currentTime = (new Date).getTime();
            startTs = currentTime - vm.timewindow.history.timewindowMs;
            endTs = null;
        } else {
            startTs = vm.timewindow.history.fixedTimewindow.startTimeMs;
            endTs = vm.timewindow.history.fixedTimewindow.endTimeMs;
        }
        return [startTs, endTs];
    }

    function getAllAlarms() {
        vm.exportInProgress = true;
        vm.exportCancelled = false;
        vm.exportRowsFetched = 0;
        var allEvents = [];
        var [startTs, endTs] = getExportTimeFrame();
        var loadEventsFunc = vm.raisedOnly ? eventService.getAllRaisedEvents : eventService.getAllEvents;

        const fetchPage = (page) => {
            return loadEventsFunc(vm.eventTypes, vm.states, vm.severities, vm.eventNames, /*vm.ituTypes,*/ vm.entityName, vm.sources, startTs, endTs, MAX_NUM_OF_EVENTS_TO_STORE, page).then(
                (result) => {
                    if (vm.exportCancelled) {
                        return null;
                    }
                    var pageData = (result && result.data) || [];
                    allEvents = allEvents.concat(pageData);
                    vm.exportRowsFetched = allEvents.length;
                    if (pageData.length === MAX_NUM_OF_EVENTS_TO_STORE) {
                        return fetchPage(page + 1);
                    }
                    return allEvents;
                },
                () => {
                    resetExporting();
                    return null;
                }
            );
        };
        return fetchPage(0);
    }

    function getEventNameText(event) {
        if (event.eventName == null) {
            return '';
        }
        return event.eventName in vm.types.eventName
            ? $translate.instant(vm.types.eventName[event.eventName].name)
            : event.eventName;
    }

    function decorateEventForExport(event) {
        var probableCause = event.probableCause != null ? event.probableCause : '';
        var descriptionPreview = probableCause.length > 200 ? probableCause.substring(0, 200) + ' ...' : probableCause;
        return {
            startTime: $filter('date')(new Date(event.timestampMillis), 'yyyy-MM-dd HH:mm:ss'),
            entity: event.source != null ? $translate.instant(vm.types.entityTypeTranslations[event.source].name) : '',
            label: event.entityName != null ? event.entityName : '',
            severity: event.severity != null ? $translate.instant(vm.types.severity[event.severity].name) : '',
            type: event.eventType != null ? $translate.instant(vm.types.eventType[event.eventType].typeName) : '',
            eventName: getEventNameText(event),
            description: descriptionPreview,
            descriptionDetails: probableCause,
            state: event.state != null ? $translate.instant(vm.types.eventState[event.state].name) : ''
        };
    }

    function sanitizeCsvValue(value) {
        if (value == null) {
            return '';
        }
        return String(value).replace(/[\r\n;]+/g, ' ');
    }

    function exportAlarms() {
        const columnsOrder = ['startTime', 'entity', 'label', 'severity', 'type', 'eventName', 'description', 'descriptionDetails', 'state'];
        getAllAlarms().then((events) => {
            if (events) {
                var csvData = events.reduce((acc, event) => {
                    var decorated = decorateEventForExport(event);
                    var row = columnsOrder.map((column) => sanitizeCsvValue(decorated[column]));
                    acc += row.join(';') + '\n';
                    return acc;
                }, '');
                var currentDate = $filter('date')((new Date).getTime(), 'yyyy-MM-dd');
                importExport.downloadFile(columnsOrder.join(';') + '\n' + csvData, currentDate + '_alarms', types.fileType.CSV);
            }
            resetExporting();
        });
    }

    function displayOpenDetails(event) {
        var authority = userService.getAuthority();
        if (authority == types.authority.PROVIDER_ADMIN.value) {
            return event.source == types.entityType.gateway;
        } else {
            return true;
        }
    }

    function getLabel($event, event) {
        if (event.source == vm.types.entityType.gateway) {
            return $translate.instant('event.gateway-details');
        } else if (event.source == vm.types.entityType.device) {
            return $translate.instant('event.device-details');
        } else if (event.source == vm.types.entityType.integration) {
            return $translate.instant('event.integration-details');
        } else {
            return $translate.instant('event.label');
        }
    }

    function getLabelIcon($event, event) {
        if (event.source == vm.types.entityType.gateway) {
            return 'router';
        } else if (event.source == vm.types.entityType.device) {
            return 'devices_other';
        } else if (event.source == vm.types.entityType.integration) {
            return 'extension';
        } else {
            return 'memory';
        }
    }

    function openEntityDetails($event, event) {
        if (event.source == types.entityType.gateway) {
            gatewayService.getGateway(event.entityId).then(
                (gateway) => {
                    $state.go('home.gatewayGroups.gateways', {gatewayGroupId: gateway.gatewayGroupId.id, entityId: {id: event.entityId, entityType: event.source}});
                }
            );
        } else if (event.source == types.entityType.device) {
            deviceService.getDevice(event.entityId).then(
                (device) => {
                    $state.go('home.applications.devices', {applicationId: device.applicationId.id, entityId: {id: event.entityId, entityType: event.source}});
                }
            );
        } else if (event.source == types.entityType.integration) {
            integrationService.getIntegration(event.entityId).then(
                (integration) => {
                    $state.go('home.applications.integrations',
                        {applicationId: integration.applicationId.id, entityId: integration.id, entityIdIntegration: {id: event.entityId, entityType: event.source}});
                }
            );
        }
    }

    function showDescriptionDetails($event, payload) {
        if (payload) {
            var onShowingCallback = {
                onShowing: function () {
                }
            };
            $mdDialog.show({
                controller: 'EventDescriptionDetailsController',
                controllerAs: 'vm',
                templateUrl: eventDescriptionDetails,
                locals: {
                    payload: payload,
                    showingCallback: onShowingCallback
                },
                parent: angular.element($document[0].body),
                targetEvent: $event,
                fullscreen: true,
                skipHide: true,
                onShowing: function (scope, event) {
                    onShowingCallback.onShowing(scope, event);
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/event/events.directive.js